import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlip = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3.38045 10C4.89083 6.75092 8.18339 4.5 12 4.5C16.4465 4.5 20.1811 7.55546 21.2155 11.6823C21.3162 12.0841 21.7235 12.3282 22.1253 12.2275C22.5271 12.1268 22.7712 11.7194 22.6705 11.3177C21.4729 6.53939 17.1507 3 12 3C7.94757 3 4.40828 5.19117 2.5 8.45159V6.75C2.5 6.33579 2.16421 6 1.75 6C1.33579 6 1 6.33579 1 6.75V10.5C1 11.0523 1.44772 11.5 2 11.5H5.75C6.16421 11.5 6.5 11.1642 6.5 10.75C6.5 10.3358 6.16421 10 5.75 10H3.38045Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.5156 17.4101C7.23084 17.1254 7.23084 16.6637 7.5156 16.3789L11.379 12.5156C11.6637 12.2308 12.1254 12.2308 12.4102 12.5156L16.2735 16.3789C16.5583 16.6637 16.5583 17.1254 16.2735 17.4101L12.4102 21.2735C12.1254 21.5583 11.6637 21.5583 11.379 21.2735L7.5156 17.4101ZM7.95754 16.8209C7.91686 16.8616 7.91686 16.9275 7.95754 16.9682L11.8209 20.8316C11.8616 20.8722 11.9275 20.8722 11.9682 20.8316L15.8316 16.9682C15.8723 16.9275 15.8723 16.8616 15.8316 16.8209L11.9682 12.9575C11.9275 12.9168 11.8616 12.9168 11.8209 12.9575L7.95754 16.8209Z",
		fill: "var(--colors-grey-1)",
		stroke: "var(--colors-grey-1)",
		strokeWidth: .7
	})]
});
export default SvgFlip;
